import { useAuth0 } from "@auth0/auth0-react"
import { useEffect } from "react";

export const authorizeComponent = () => {
    const { isLoading, user, loginWithRedirect } = useAuth0();
    useEffect(() => {
        if (!isLoading && user == null) {
            loginWithRedirect({
                authorizationParams: {
                    prompt: "consent",
                    redirect_uri: `${window.location.protocol}//${window.location.host}`
                }
            });
        }
    }, [isLoading, user]);
}